import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import './index.scss'

dayjs.extend(relativeTime)

const TOLGEE_PREFIX = 'VideoCard-LivePostDate'
const LIVE_DATE_TRANSLATION = {
  finished: {
    key: `${TOLGEE_PREFIX}-finishedDate`,
    defaultValue: 'Streamed {date}',
  },
  inProgress: TOLGEE_GLOBALS.liveNow,
  scheduled: {
    key: `${TOLGEE_PREFIX}-scheduledDate`,
    defaultValue: 'Scheduled for {date}',
  },
}
const LIVE_DATE_FORMATTING = {
  finished: {
    dateKey: 'startTime',
    formatDate: date => dayjs(date).from(dayjs()),
  },
  inProgress: {
    dateKey: '',
    formatDate: date => date,
  },
  scheduled: {
    dateKey: 'scheduledTime',
    formatDate: date => dayjs(date).format('DD/MM/YYYY, HH:mm'),
  },
}

function LivePostDate({ live }) {
  if (!live) {
    return null
  }

  const dateTranslation = LIVE_DATE_TRANSLATION?.[live?.state]
  const dateFormatting = LIVE_DATE_FORMATTING?.[live?.state]

  return (
    <div className="VideoCard-LivePostDate">
      <T
        keyName={dateTranslation.key}
        parameters={{
          date: dateFormatting?.formatDate(live?.[dateFormatting?.dateKey]),
        }}
      >
        {dateTranslation.defaultValue}
      </T>
    </div>
  )
}

export default LivePostDate
